import React, { useMemo, useState } from "react";
import { convertWeightToHumanReadable, percentOf } from "@/Utilities/Utilities";

export function EmissionList({ items = [], total = 0 }) {
  const [isActive, setIsActive] = useState(false);
  const limit = useMemo(() => (isActive ? null : 3), [isActive]);

  return (
    <div className="divider-y flex flex-col gap-2">
      {items.map((item, i) => {
        if (limit && i >= limit) return;
        return (
          <div
            key={i}
            className="flex flex-col justify-between sm:flex-row sm:items-center sm:gap-4 lg:flex lg:flex-col lg:items-start lg:justify-between lg:gap-0 3xl:flex-row 3xl:items-center 3xl:gap-4"
          >
            <p className="font-bold">{item.name}</p>
            <p className="sm:text-right lg:text-left 3xl:text-right">
              {convertWeightToHumanReadable(item.value, true)?.concat}{" "}
              CO₂e&nbsp;(
              {percentOf(item.value, total, 0)}%)
            </p>
          </div>
        );
      })}
      {items.length > 3 && (
        <span
          className="cursor-pointer underline hover:no-underline"
          onClick={() => setIsActive(!isActive)}
        >
          {isActive ? "Show less" : "Show more"}
        </span>
      )}
    </div>
  );
}
